import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import titleIcon from '../../asset/img/myinfo_title_img.svg';
import Typography from '../../components/common/Typography';

const Title = () => {
  const { myInfo } = useSelector(state => state.myInfo);

  const [userInfo, setUserInfo] = useState({
    name: '김월급',
    department: '급여연구소 · 디자인파트',
    position: '팀장',
    htmpersabun: '20201002',
  });

  return (
    <div className="myinfoTitle">
      {/* 내정보 */}
      <div>
        <Typography>
          {myInfo?.htmComNm}
          {myInfo?.htmGrpNm && '·'}
          {myInfo?.htmGrpNm}
        </Typography>
        <div className="displayFlex">
          <Typography variant="subtitleBold">{myInfo?.htmInsaPerNm}</Typography>
          <Typography variant="subtitleMedium">({myInfo?.htmPerSabun?.trim()})</Typography>
        </div>
      </div>
      {/* 이미지 */}
      <img src={titleIcon} alt="titleIcon" />
    </div>
  );
};

export default Title;
